__turbopack_context__.v({
  "effects": "Arrow-module-scss-module__uNpkQa__effects",
  "flip": "Arrow-module-scss-module__uNpkQa__flip",
  "left": "Arrow-module-scss-module__uNpkQa__left",
  "right": "Arrow-module-scss-module__uNpkQa__right",
});
